const translation = {
    "addOrder": "הוספת הזמנה",
    "unapprovedOrders": "הזמנות שלא אושרו",
    "orderList": "רשימת הזמנות",
    "allOrdersHistory": "היסטוריית כל ההזמנות",
    "myOrders": "ההזמנות שלי",
    "allOrders": "כל ההזמנות",
    "orderingCustomer": "לקוח מזמין",
    "receivingCustomer": "לקוח מקבל",
    "site": "אתר",
    "deliveryAddress": "כתובת למשלוח",
    "deliveryDate": "תאריך אספקה",
    "productDescription": "תיאור מוצר",
    "quantity": "כמות",
    "partName": "מק\"ט",
    "loading": "טוען...",
    "errorFetchingOrders": "שגיאה בעיבוד נתונים, פנה למנהל המערכת.",
    "orderUpdatedByUser": "ההזמנה עודכנה ע\"י משתמש"

  };

  export default translation;
  